import { multipleBeacons } from 'app-webtech-core/beacon/multipleBeacons';
import { withFields } from 'app-webtech-core/beacon/withFields';
import { channelChangeBeacon } from './channelChange';
import { adClickChannelChangeBeacon } from './adClickChannelChange';
import { scrollVerticalBeacon } from './scrollVertical';

import {
  SELECT_DOWN,
  SELECT_UP,
  CHANNEL_ERROR,
  CHANGE_CURRENT_PLAYING_FOR_BI,
  AD_CLICK_CHANNEL_CHANGE_FOR_BI,
} from '../actions/types';
import { channelErrorBeacon } from './channelError';
import { msnPlayerLoadingBeacon } from '../../player/beacons/msnPlayerLoading';

export const guideEventDefinitionsMap = {
  [CHANGE_CURRENT_PLAYING_FOR_BI]: multipleBeacons(
    withFields(channelChangeBeacon),
    msnPlayerLoadingBeacon,
  ),
  [SELECT_DOWN]: withFields(scrollVerticalBeacon),
  [SELECT_UP]: withFields(scrollVerticalBeacon),
  [CHANNEL_ERROR]: withFields(channelErrorBeacon),
  [AD_CLICK_CHANNEL_CHANGE_FOR_BI]: withFields(adClickChannelChangeBeacon),
};
